import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Clock, ArrowRight } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default function TrialEnded() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 flex items-center justify-center p-4">
      <div className="absolute top-4 right-4 flex items-center gap-2">
        <LanguageSwitcher />
        <Button variant="ghost" size="sm" onClick={logout}>
          {t('auth.signOut')}
        </Button>
      </div>
      <Card className="max-w-md w-full p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 mb-5">
          <Clock className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">{t('trialEnded.title')}</h1>
        <p className="text-slate-600 mb-6">{t('trialEnded.subtitle')}</p>
        <div className="space-y-3">
          <Link to="/pricing">
            <Button className="w-full bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white">
              {t('trialEnded.upgrade')}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/pricing">
            <Button variant="outline" className="w-full">
              {t('trialEnded.viewPlans')}
            </Button>
          </Link>
        </div>
        <p className="text-xs text-slate-500 mt-6">{t('trialEnded.support')}</p>
      </Card>
    </div>
  );
}
